import {
    Box,
    CircularProgress,
    Grid,
    makeStyles,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow
} from "@material-ui/core";
import { useCallback, useEffect, useState } from "react";

import DeleteIcon from "@material-ui/icons/Delete";
import ShareIcon from '@material-ui/icons/Share';
import _ from "lodash";
import moment from "moment";
import { LuArrowDown, LuArrowDownUp, LuArrowUp } from "react-icons/lu";
import SearchBar from "../../../common/Search";
import CustomTabs from "../../../common/Tabs";
import CustomTooltip from "../../../common/Tooltip";
import CustomAddModal from "../../../components/Common/CustomAddModal";
import CustomConfirmModal from "../../../components/Common/CustomConfirmModal";
import CustomPagination from "../../../components/Common/CustomPagination";
import ShareWithOrg from "../../../components/Common/ShareWithOrg";
import { getCurrentUserId, getCurrentUserOrganizationId, toastError, toastSuccess } from "../../../utils";
import * as actions from "./actions";

const useStyles = makeStyles({
    root: {
        width: "fit-content",
    },
    tableContainer: {
        "& .universal-table tbody tr .MuiTableCell-root, & .universal-table tbody tr td": {
            paddingTop: "4px !important",
            paddingBottom: "4px !important",
        },
    },
});

const initialSearchType = {
    type: "",
    saveLabel: "",
    name: "",
    firstLoadPort: "",
    lastDischargePort: "",
    loadQuantity: "",
    createdDate: "",
};

function CargoAnalysis(props) {
    const { setLoader = () => { } } = props;
    const classes = useStyles();

    const [value, setValue] = useState(1);
    const [open, setOpen] = useState(false);
    const [isEdit, setIsEdit] = useState(false);

    const [savedResults, setSavedResults] = useState([]);
    const [allSavedResults, setAllSavedResults] = useState([]);

    const [searchType, setSearchType] = useState({ ...initialSearchType });

    const [myFilters, setMyFilters] = useState({
        offset: 1,
        limit: 50,
        sortBy: "createdDate",
        sortDirection: "desc",
    });
    const [allFilters, setAllFilters] = useState({
        offset: 1,
        limit: 50,
        sortBy: "createdDate",
        sortDirection: "desc",
    });

    const [deleteModal, setDeleteModal] = useState(false);
    const [deleteId, setDeleteId] = useState({});

    const [isShareConfirm, setShareConfirm] = useState(false);
    const [getSingleCargoData, setSingleCargoData] = useState("");
    const [shareLabel, setShareLabel] = useState("");

    const organizationId = getCurrentUserOrganizationId();
    // const addDetailsModalRef = useRef();
    const [searchValue, setSearchValue] = useState("");
    const onSearchVessel = (search) => {
        getAllSavedResults(search);
        getAllOrgSavedResults(search);
    };
    const delaySearch = useCallback(
        _.debounce((data) => onSearchVessel(data), 500),
        []
    );
    const onSearchChange = (e) => {
        setSearchValue(e.target.value)
        delaySearch(e.target.value);
    }

    const [hasFetchedUser, setHasFetchedUser] = useState(false);
    const [hasFetchedOrg, setHasFetchedOrg] = useState(false);
    const [isInitialUserLoading, setIsInitialUserLoading] = useState(true);
    const [isInitialOrgLoading, setIsInitialOrgLoading] = useState(true);

    useEffect(() => {
        if (value === 1) getAllSavedResults(searchValue);
        if (value === 2) getAllOrgSavedResults(searchValue);
    }, [value, myFilters.offset, myFilters.sortBy, myFilters.sortDirection, allFilters.offset, allFilters.sortBy, allFilters.sortDirection]);

    const getAllSavedResults = async (search) => {
        if (!hasFetchedUser && (!savedResults || savedResults.length === 0)) {
            setIsInitialUserLoading(true);
            setLoader(true);
        }
        await actions
            .getCargoAnalysisDetails({
                userId: getCurrentUserId(),
                search: search,
                offset: myFilters.offset,
                limit: myFilters.limit,
                sortBy: myFilters.sortBy,
                sortDirection: myFilters.sortDirection
            })
            .then((res) => {
                setIsInitialUserLoading(false);
                setLoader(false);
                setHasFetchedUser(true);
                setSavedResults(res?.data?.list || []);
                setMyFilters(prev => ({
                    ...prev,
                    totalPages: res?.data?.totalItems,
                    offset: res?.data?.currentPage,
                    pageCount: res?.data?.totalPages,
                    limit: res?.data?.perPage
                }))
            })
            .catch((err) => {
                setIsInitialUserLoading(false);
                setLoader(false);
                setHasFetchedUser(true);
                toastError(err?.data?.message);
            });
    };

    const getAllOrgSavedResults = async (search) => {
        if (!hasFetchedOrg && (!allSavedResults || allSavedResults.length === 0)) {
            setIsInitialOrgLoading(true);
            setLoader(true);
        }
        await actions
            .getAllCargoAnalysisDetails({
                organizationId: organizationId,
                search: search,
                offset: allFilters.offset,
                limit: allFilters.limit,
                sortBy: allFilters.sortBy,
                sortDirection: allFilters.sortDirection
            })
            .then((res) => {
                setIsInitialOrgLoading(false);
                setLoader(false);
                setHasFetchedOrg(true);
                setAllSavedResults(res?.data?.list || []);
                setAllFilters(prev => ({
                    ...prev,
                    totalPages: res?.data?.totalItems,
                    offset: res?.data?.currentPage,
                    pageCount: res?.data?.totalPages,
                    limit: res?.data?.perPage
                }))
            })
            .catch((err) => {
                setIsInitialOrgLoading(false);
                setLoader(false);
                setHasFetchedOrg(true);
                toastError(err?.data?.message);
            });
    };


    const onClickDeletAddress = (id) => {
        setDeleteId(id);
        setDeleteModal(true);
    };



    const onChangeMyPagination = (type = "") => {
        let newMyFilters = {};
        if (type === "inc") {
            newMyFilters = { ...myFilters, offset: myFilters.offset + 1 };
        } else if (type === "first") {
            newMyFilters = { ...myFilters, offset: 1 };
        } else {
            if (myFilters.offset === 1) return;
            newMyFilters = { ...myFilters, offset: myFilters.offset - 1 };
        }
        setMyFilters(newMyFilters);
    };

    const handleMySortClick = (sortKey) => {
        let newSortDirection = "asc";
        if (myFilters.sortBy === sortKey) {
            if (myFilters.sortDirection === "asc") newSortDirection = "desc";
            else if (myFilters.sortDirection === "desc") {
                newSortDirection = sortKey === "createdDate" ? "asc" : "";
            }
        } else {
            newSortDirection = sortKey === "createdDate" ? "desc" : "asc";
        }

        let nextSortBy = sortKey;
        if (!newSortDirection) {
            nextSortBy = "createdDate";
            newSortDirection = "desc";
        }

        setMyFilters((prev) => ({
            ...prev,
            offset: 1,
            sortBy: nextSortBy,
            sortDirection: newSortDirection,
        }));
    };

    const onChangeAllPagination = (type = "") => {
        let newallFilters = {}
        if (type === "inc") {
            newallFilters = { ...allFilters, offset: allFilters.offset + 1 };
        } else if (type === "first") {
            newallFilters = { ...allFilters, offset: 1 };
        } else {
            if (allFilters.offset === 1) return;
            newallFilters = { ...allFilters, offset: allFilters.offset - 1 };
        }
        setAllFilters(newallFilters);
    };

    const handleAllSortClick = (sortKey) => {
        let newSortDirection = "asc";
        if (allFilters.sortBy === sortKey) {
            if (allFilters.sortDirection === "asc") newSortDirection = "desc";
            else if (allFilters.sortDirection === "desc") {
                newSortDirection = sortKey === "createdDate" ? "asc" : "";
            }
        } else {
            newSortDirection = sortKey === "createdDate" ? "desc" : "asc";
        }

        let nextSortBy = sortKey;
        if (!newSortDirection) {
            nextSortBy = "createdDate";
            newSortDirection = "desc";
        }

        setAllFilters((prev) => ({
            ...prev,
            offset: 1,
            sortBy: nextSortBy,
            sortDirection: newSortDirection,
        }));
    };

    const onDeleteCargoAnalysis = () => {
        actions
            .deleteCargoAnalysis(deleteId)
            .then(() => {
                toastSuccess("Result deleted successfully");
                setDeleteModal(false);
                setDeleteId("");
                getAllSavedResults();
            })
            .catch(() => {
                toastError();
            });
    };

    const onShareOrgSaveClick = async () => {
        if (!organizationId) {
            toastError("You are not part of any organization!");
            return
        }
        if (!shareLabel || !getSingleCargoData) return
        let { _id, ...data } = getSingleCargoData
        data.access = "public"
        data.organizationId = organizationId
        data.cargoAnalysisName = shareLabel
        data.userId = null

        await actions
            .addTeamCargoAnalysisDetails(data)

        setShareConfirm(false)
        setShareLabel("")
        getAllOrgSavedResults()
    }
    const onShareOrgClick = (item) => {
        setShareConfirm(!isShareConfirm)
        setSingleCargoData(item ? item : "")
        setShareLabel("")
    }
    const handleDateRangeChange = async (newDateRange) => {
        const { startDate, endDate } = newDateRange;

        // Ensure dates are in ISO string format
        const formattedStartDate = startDate?.toISOString() || '';
        const formattedEndDate = endDate?.toISOString() || '';

        const { data } = await actions.getCargoAnalysisDetails({
            userId: getCurrentUserId(),
            startDate: formattedStartDate,
            endDate: formattedEndDate
        });
        setSavedResults(data.list);
    };

    const tabs = [
        { key: 1, label: "My Cargo", tooltip: "Displays cargo analysis entries created by you." },
        { key: 2, label: "All Cargo", tooltip: "Displays all cargo analysis entries shared with your organization" },
    ];

    return (
        <Grid container alignContent="flex-start" className="min-h-[calc(100vh-106px)]">
            <Grid item xs={12}>
                <Box
                    display="flex"
                    alignItems="center"
                    position="relative"
                    width="100%"
                >
                    <Box>
                        <CustomTabs tabs={tabs} active={value} setActive={setValue} />
                    </Box>

                    <Box
                        position="absolute"
                        left="50%"
                        sx={{
                            transform: 'translateX(-50%)',
                            display: { xs: 'none', md: 'block' } // Desktop view
                        }}
                    >
                        <div className="desktop-searchbar">
                            <SearchBar
                                onDateRangeChange={handleDateRangeChange}
                                placeholder={"Search with Cargo Name..."}
                                setSearchValue={onSearchChange}
                                searchValue={searchValue}
                            />
                        </div>
                    </Box>

                </Box>

                {/* Mobile search bar */}
                <Box
                    className="md:hidden"
                    display="flex"
                    justifyContent="center"
                    mt={2}
                >
                    <div className="w-full">
                        <SearchBar
                            isMobile
                            onDateRangeChange={handleDateRangeChange}
                            placeholder={"Search with Cargo Name..."}
                            setSearchValue={onSearchChange}
                            searchValue={searchValue}
                        />
                    </div>
                </Box>
            </Grid>

            <Grid item xs={12}></Grid>

            <Grid item xs={12}>
                {value === 1 ? <Box pt={2}>
                    <TableContainer component={Paper} className={classes.tableContainer}>
                        {myFilters?.totalPages > myFilters?.limit && (
                            <CustomPagination
                                onChangePagination={onChangeMyPagination}
                                filters={myFilters}
                                totalPage={myFilters?.totalPages}
                            />
                        )}
                        <Table className="universal-table fit-content-mobile">
                            <TableHead className="bg-[#313C4C]">
                                <TableRow>
                                    {[
                                        { label: "No.", sortKey: null },
                                        { label: "Cargo Name", sortKey: "clientQuery.name" },
                                        { label: "Vessel Name", sortKey: "vessel.vesselName" },
                                        { label: "First Load Port", sortKey: null },
                                        { label: "Last Discharge Port", sortKey: null },
                                        { label: "Cargo", sortKey: null },
                                        { label: "Customer", sortKey: null },
                                        { label: "Created on", sortKey: "createdDate" },
                                        { label: "Created By", sortKey: null },
                                        { label: "Action", sortKey: null, align: "center" },
                                    ].map((header, index, array) => (
                                        <TableCell
                                            key={header.label}
                                            className={`py-2 border-r border-gray-400 whitespace-nowrap ${index === array.length - 1 ? "border-r-0" : ""
                                                } ${header.sortKey ? "cursor-pointer" : ""}`}
                                            onClick={() => header.sortKey ? handleMySortClick(header.sortKey) : undefined}
                                            style={{ textAlign: header.align || "left" }}
                                        >
                                            <div style={{ display: "flex", alignItems: "center", justifyContent: header.align === "center" ? "center" : "flex-start", gap: 4 }}>
                                                {header.label}
                                                {header.sortKey && (
                                                    <div
                                                        style={{
                                                            color: myFilters.sortBy === header.sortKey ? "#fff" : "rgba(255,255,255,0.4)",
                                                            display: "flex",
                                                            alignItems: "center",
                                                        }}
                                                    >
                                                        {myFilters.sortBy === header.sortKey && myFilters.sortDirection === "desc" ? (
                                                            <LuArrowDown size={14} />
                                                        ) : myFilters.sortBy === header.sortKey && myFilters.sortDirection === "asc" ? (
                                                            <LuArrowUp size={14} />
                                                        ) : (
                                                            <LuArrowDownUp size={14} />
                                                        )}
                                                    </div>
                                                )}
                                            </div>
                                        </TableCell>
                                    ))}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {isInitialUserLoading && (!Array.isArray(savedResults) || !savedResults.length) ? (
                                    <TableRow>
                                        <TableCell colSpan={10} align="center" className="!bg-white">
                                            <Box display="flex" justifyContent="center" alignItems="center" height="440px">
                                                {savedResults?.length > 0 && <CircularProgress />}
                                            </Box>
                                        </TableCell>
                                    </TableRow>
                                ) : Array.isArray(savedResults) && savedResults.length ? (
                                    savedResults.map((item, index) => {
                                        return <TableRow
                                            key={index}
                                            className={`hover:bg-gray-50 cursor-pointer ${classes.tableRow} [&>td]:!py-2`}
                                            onDoubleClick={() => window.open(`/cargo-analysis/estimation/${item._id}`, "_blank")}
                                        >
                                            <TableCell>{index + 1}</TableCell>
                                            <TableCell>

                                                <a
                                                    style={{ color: "blue" }}
                                                    href={`/cargo-analysis/estimation/${item._id}`}
                                                    target="_blank"
                                                    rel="noreferrer"
                                                >
                                                    {item?.clientQuery?.name || "-"}
                                                </a>
                                            </TableCell>
                                            <TableCell>{item?.vessel?.vesselName || "-"}</TableCell>
                                            <TableCell>
                                                {item?.clientQuery?.cargoList?.find(item => item.operation?.toLowerCase() === "loading")?.port || "-"}
                                            </TableCell>
                                            <TableCell>
                                                {item?.clientQuery?.cargoList?.slice()?.reverse()?.find(item => item.operation?.toLowerCase() === "discharging")?.port || "-"}
                                            </TableCell>
                                            <TableCell>
                                                {item?.clientQuery?.cargoList?.find(item => item.operation?.toLowerCase() === "loading")?.cargo || "-"}
                                            </TableCell>
                                            <TableCell>{item?.clientQuery?.cargoList?.find(item => item.operation?.toLowerCase() === "loading")?.account || "-"}</TableCell>
                                            <TableCell>{moment(item.createdDate).format("DD/MM/YYYY")}</TableCell>
                                            <TableCell>{item?.createdUserName || "-"}</TableCell>

                                            <TableCell style={{ textAlign: "center" }}>
                                                <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 8 }}>
                                                    <CustomTooltip position="top" text="Share with your Team">
                                                        <ShareIcon
                                                            color="primary"
                                                            style={{ cursor: "pointer" }}
                                                            onClick={() => onShareOrgClick(item)}
                                                        />
                                                    </CustomTooltip>
                                                    <CustomTooltip position="top" text="Delete">
                                                        <DeleteIcon
                                                            color="secondary"
                                                            style={{ cursor: "pointer" }}
                                                            onClick={() => onClickDeletAddress(item?._id)}
                                                        />
                                                    </CustomTooltip>
                                                </div>
                                            </TableCell>
                                        </TableRow>

                                    })
                                ) : (
                                    <TableRow>
                                        <TableCell
                                            colSpan="8"
                                            align="center"
                                            className="!bg-white"
                                        >
                                            No Cargo Details Found.
                                        </TableCell>
                                    </TableRow>
                                )}
                            </TableBody>
                        </Table>
                        {myFilters?.totalPages > myFilters?.limit && (
                            <CustomPagination
                                onChangePagination={onChangeMyPagination}
                                filters={myFilters}
                                totalPage={myFilters?.totalPages}
                            />
                        )}
                    </TableContainer>
                </Box>
                    : <Box pt={2}>
                        <TableContainer component={Paper} className={classes.tableContainer}>
                            {allFilters?.totalPages > allFilters?.limit && (
                                <CustomPagination
                                    onChangePagination={onChangeAllPagination}
                                    filters={allFilters}
                                    totalPage={allFilters?.totalPages}
                                />
                            )}
                            <Table className="universal-table fit-content-mobile">
                                <TableHead className="bg-[#313C4C]">
                                    <TableRow>
                                        {[
                                            { label: "No.", sortKey: null },
                                            { label: "Cargo Name", sortKey: "clientQuery.name" },
                                            { label: "Vessel Name", sortKey: "vessel.vesselName" },
                                            { label: "First Load Port", sortKey: null },
                                            { label: "Last Discharge Port", sortKey: null },
                                            { label: "Cargo", sortKey: null },
                                            { label: "Customer", sortKey: null },
                                            { label: "Created on", sortKey: "createdDate" },
                                            { label: "Created By", sortKey: null },
                                        ].map((header, index, array) => (
                                            <TableCell
                                                key={header.label}
                                                className={`text-white py-2 border-r border-gray-400 whitespace-nowrap ${index === array.length - 1 ? "border-r-0" : ""
                                                    } ${header.sortKey ? "cursor-pointer" : ""}`}
                                                onClick={() => header.sortKey ? handleAllSortClick(header.sortKey) : undefined}
                                            >
                                                <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
                                                    {header.label}
                                                    {header.sortKey && (
                                                        <div
                                                            style={{
                                                                color: allFilters.sortBy === header.sortKey ? "#fff" : "rgba(255,255,255,0.4)",
                                                                display: "flex",
                                                                alignItems: "center",
                                                            }}
                                                        >
                                                            {allFilters.sortBy === header.sortKey && allFilters.sortDirection === "desc" ? (
                                                                <LuArrowDown size={14} />
                                                            ) : allFilters.sortBy === header.sortKey && allFilters.sortDirection === "asc" ? (
                                                                <LuArrowUp size={14} />
                                                            ) : (
                                                                <LuArrowDownUp size={14} />
                                                            )}
                                                        </div>
                                                    )}
                                                </div>
                                            </TableCell>
                                        ))}
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {isInitialOrgLoading && (!Array.isArray(allSavedResults) || !allSavedResults.length) ? (
                                        <TableRow>
                                            <TableCell colSpan={10} align="center" className="!bg-white">
                                                <Box display="flex" justifyContent="center" alignItems="center" height="440px">
                                                    {allSavedResults?.length > 0 && <CircularProgress />}
                                                </Box>
                                            </TableCell>
                                        </TableRow>
                                    ) : Array.isArray(allSavedResults) && allSavedResults.length ? (
                                        allSavedResults.map((item, index) => {
                                            return <TableRow
                                                key={index}
                                                className={`hover:bg-gray-50 cursor-pointer ${classes.tableRow} [&>td]:!py-2`}
                                                onDoubleClick={() => window.open(`/cargo-analysis/estimation/${item?._id}`, "_blank")}
                                            >
                                                <TableCell>{index + 1}</TableCell>
                                                <TableCell>

                                                    <a
                                                        style={{ color: "blue" }}
                                                        href={`/cargo-analysis/estimation/${item?._id}`}
                                                        target="_blank"
                                                        rel="noreferrer"
                                                    >
                                                        {item?.clientQuery?.name || "-"}
                                                    </a>
                                                </TableCell>
                                                <TableCell>{item?.vessel?.vesselName || "-"}</TableCell>

                                                <TableCell>
                                                    {item?.clientQuery?.cargoList?.find(item => item.operation?.toLowerCase() === "loading")?.port || "-"}
                                                </TableCell>
                                                <TableCell>
                                                    {item?.clientQuery?.cargoList?.slice()?.reverse()?.find(item => item.operation?.toLowerCase() === "discharging")?.port || "-"}
                                                </TableCell>
                                                <TableCell>
                                                    {item?.clientQuery?.cargoList?.find(item => item.operation?.toLowerCase() === "loading")?.cargo || "-"}
                                                </TableCell>
                                                <TableCell>{item?.clientQuery?.cargoList?.find(item => item.operation?.toLowerCase() === "loading")?.account || "-"}</TableCell>
                                                <TableCell>{moment(item.createdAt).format("DD/MMM/yyyy")}</TableCell>
                                                <TableCell>{item?.createdUserName || "-"}</TableCell>

                                                {/* <TableCell>
                                                    <div className="query-actions">
                                                        
                                                        <DeleteIcon
                                                            color="secondary"
                                                            onClick={() =>
                                                                onClickDeletAddress(item?._id)
                                                            }
                                                        />
                                                    </div>
                                                </TableCell> */}
                                            </TableRow>

                                        })
                                    ) : (
                                        <TableRow>
                                            <TableCell
                                                colSpan="8"
                                                align="center"
                                                className="!bg-white"
                                            >
                                                No Cargo Details Found.
                                            </TableCell>
                                        </TableRow>
                                    )}
                                </TableBody>
                            </Table>
                            {allFilters?.totalPages > allFilters?.limit && (
                                <CustomPagination
                                    onChangePagination={onChangeAllPagination}
                                    filters={allFilters}
                                    totalPage={allFilters?.totalPages}
                                />
                            )}
                        </TableContainer>
                    </Box>}
            </Grid>

            <CustomConfirmModal
                open={deleteModal}
                handleClose={() => setDeleteModal(false)}
                message="Are you sure you want to delete this cargo analysis?"
                onSubmitConfirm={onDeleteCargoAnalysis}
                type="warning"
                confirmText="DELETE"
                cancelText="Cancel"
                note="This action cannot be undone."
            />
            <CustomAddModal
                open={isShareConfirm}
                handleClose={onShareOrgClick}
                onSubmitConfirm={onShareOrgSaveClick}
                maxWidth="xs"
                saveLabel="Share"
                title="Share with Team"
            >
                <ShareWithOrg
                    value={shareLabel}
                    onChange={(e) => setShareLabel(e.target.value)}
                    placeholder="Enter Cargo Analysis name*"
                    label="Team copy name"
                    guidanceTitle="Share this cargo analysis"
                    guidance="Create a team copy of this cargo analysis. Your team can find it in Cargo Analysis → All Cargo."
                />
            </CustomAddModal>
        </Grid>
    );
}

export default CargoAnalysis;
